import { paths } from "@clockwise/client-commons/src/constants/site";
import { fg_muted } from "@clockwise/design-system/tokens";
import { OpenInNew, PageInfo } from "@clockwise/icons";
import { EcosystemEnum } from "@clockwise/schema";
import { webappDefaultWindowName } from "@clockwise/web-commons/src/constants/route.constants";
import { useEcosystem } from "@clockwise/web-commons/src/util/ecosystem";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import React from "react";
import { Divider } from "../../calendar-popover/atoms/Divider";
import { ListItemButton } from "../../calendar-popover/atoms/ListItemButton";

export const EditSettingsLink = () => {
  const ecosystem = useEcosystem();
  const onClickEditSettings = () => {
    if (ecosystem === EcosystemEnum.Microsoft) {
      window.open(
        `${paths.webApp}${paths.webSettings}/account/smart-holds/travel-time`,
        "web-settings",
      );
    } else {
      window.open(getUrlForFeature("accountPreferences"), webappDefaultWindowName);
    }
  };

  return (
    <>
      <Divider />
      <ListItemButton
        startIcon={PageInfo}
        endIcon={OpenInNew}
        onClick={onClickEditSettings}
        startIconColor={fg_muted}
        endIconColor={fg_muted}
      >
        Edit settings
      </ListItemButton>
    </>
  );
};
